export const InteractivePromoIcon = () => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" id="eb-promo" viewBox="0 0 64 64">
			<linearGradient
				id="SVGID_1__43971"
				gradientUnits="userSpaceOnUse"
				x1="37"
				y1="16.125"
				x2="37"
				y2="22.38"
				spreadMethod="reflect"
			>
				<stop offset="0" stopColor="#6dc7ff" />
				<stop offset="1" stopColor="#e6abff" />
			</linearGradient>
			<path
				d="M42,22H32c-0.552,0-1-0.448-1-1v-4c0-0.552,0.448-1,1-1h10c0.552,0,1,0.448,1,1v4 C43,21.552,42.552,22,42,22z"
				fill="url(#SVGID_1__43971)"
			/>
			<linearGradient
				id="SVGID_2__43971"
				gradientUnits="userSpaceOnUse"
				x1="39.5"
				y1="10"
				x2="39.5"
				y2="54.388"
				spreadMethod="reflect"
			>
				<stop offset="0" stopColor="#1a6dff" />
				<stop offset="1" stopColor="#c822ff" />
			</linearGradient>
			<path
				d="M58,36c0-2.967-2.167-5.431-5-5.91v-7.004c0-0.777-0.435-1.468-1.135-1.805 c-0.7-0.335-1.511-0.244-2.119,0.241l-7.996,6.396c-0.03,0.024-0.052,0.055-0.081,0.081H30c-2.757,0-5,2.243-5,5h-2 c-1.103,0-2,0.897-2,2v2c0,1.103,0.897,2,2,2h2c0,2.757,2.243,5,5,5v6c0,2.206,1.794,4,4,4s4-1.794,4-4v-6h3.669 c0.029,0.026,0.051,0.057,0.082,0.082l7.995,6.396c0.365,0.292,0.804,0.441,1.247,0.441c0.295,0,0.593-0.066,0.872-0.2 C52.565,50.382,53,49.69,53,48.914V41.91C55.833,41.431,58,38.967,58,36z M23,37v-2h2v2H23z M36,50c0,1.103-0.897,2-2,2 s-2-0.897-2-2v-6h4V50z M30,42c-1.654,0-3-1.346-3-3v-6c0-1.654,1.346-3,3-3h11v12h-3H30z M50.996,48.916L43,42.518V29.479l4-3.197 V36h2V24.684l2-1.598l0.002,25.834C51.002,48.92,51,48.919,50.996,48.916z M53,39.858v-7.716c1.72,0.447,3,2,3,3.858 S54.72,39.411,53,39.858z"
				fill="url(#SVGID_2__43971)"
			/>
			<linearGradient
				id="SVGID_3__43971"
				gradientUnits="userSpaceOnUse"
				x1="31"
				y1="10"
				x2="31"
				y2="54.388"
				spreadMethod="reflect"
			>
				<stop offset="0" stopColor="#1a6dff" />
				<stop offset="1" stopColor="#c822ff" />
			</linearGradient>
			<path
				d="M29,34v2h2v-2h2v-2h-2C29.897,32,29,32.897,29,34z"
				fill="url(#SVGID_3__43971)"
			/>
			<linearGradient
				id="SVGID_4__43971"
				gradientUnits="userSpaceOnUse"
				x1="27.5"
				y1="10"
				x2="27.5"
				y2="54.388"
				spreadMethod="reflect"
			>
				<stop offset="0" stopColor="#1a6dff" />
				<stop offset="1" stopColor="#c822ff" />
			</linearGradient>
			<path
				d="M8,40V15c0-1.654,1.346-3,3-3h33c1.654,0,3,1.346,3,3v4h2v-4c0-2.757-2.243-5-5-5H11 c-2.757,0-5,2.243-5,5v25c0,2.757,2.243,5,5,5h12v-2H11C9.346,43,8,41.654,8,40z"
				fill="url(#SVGID_4__43971)"
			/>
			<linearGradient
				id="SVGID_5__43971"
				gradientUnits="userSpaceOnUse"
				x1="19"
				y1="10"
				x2="19"
				y2="54.388"
				spreadMethod="reflect"
			>
				<stop offset="0" stopColor="#1a6dff" />
				<stop offset="1" stopColor="#c822ff" />
			</linearGradient>
			<rect x="12" y="16" width="14" height="2" fill="url(#SVGID_5__43971)" />
			<linearGradient
				id="SVGID_6__43971"
				gradientUnits="userSpaceOnUse"
				x1="19"
				y1="10"
				x2="19"
				y2="54.388"
				spreadMethod="reflect"
			>
				<stop offset="0" stopColor="#1a6dff" />
				<stop offset="1" stopColor="#c822ff" />
			</linearGradient>
			<rect x="12" y="20" width="14" height="2" fill="url(#SVGID_6__43971)" />
			<linearGradient
				id="SVGID_7__43971"
				gradientUnits="userSpaceOnUse"
				x1="17"
				y1="10"
				x2="17"
				y2="54.388"
				spreadMethod="reflect"
			>
				<stop offset="0" stopColor="#1a6dff" />
				<stop offset="1" stopColor="#c822ff" />
			</linearGradient>
			<rect x="12" y="24" width="10" height="2" fill="url(#SVGID_7__43971)" />
			<linearGradient
				id="SVGID_8__43971"
				gradientUnits="userSpaceOnUse"
				x1="16"
				y1="10"
				x2="16"
				y2="54.388"
				spreadMethod="reflect"
			>
				<stop offset="0" stopColor="#1a6dff" />
				<stop offset="1" stopColor="#c822ff" />
			</linearGradient>
			<rect x="12" y="28" width="8" height="2" fill="url(#SVGID_8__43971)" />
		</svg>
	);
};
